"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "molteno": {
    "pascolo": [{
      "hkey": "2b35f2ac",
      "slug": "case-manzoni-pascolo-coroldo",
      "name": "Case Manzoni-Pascolo-Coroldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "molteno"
    }],
    "ae29e517": [{
      "hkey": "867eed46",
      "slug": "molteno",
      "name": "Molteno",
      "primary": true,
      "skipSearch": false
    }],
    "raviola": [{
      "hkey": "867eed46",
      "slug": "molteno",
      "name": "Molteno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "23cf7865": [{
      "hkey": "2b35f2ac",
      "slug": "case-manzoni-pascolo-coroldo",
      "name": "Case Manzoni-Pascolo-Coroldo",
      "primary": true,
      "skipSearch": false
    }],
    "coroldo": [{
      "hkey": "2b35f2ac",
      "slug": "case-manzoni-pascolo-coroldo",
      "name": "Case Manzoni-Pascolo-Coroldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ea9532dc": [{
      "hkey": "d6fc6f4a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "gaesso": [{
      "hkey": "d6fc6f4a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "molteno"
    }],
    "ec104e01": [{
      "hkey": "867eed46",
      "slug": "molteno",
      "name": "Molteno",
      "primary": true,
      "skipSearch": false
    }],
    "molera": [{
      "hkey": "867eed46",
      "slug": "molteno",
      "name": "Molteno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5f29c57": [{
      "hkey": "867eed46",
      "slug": "molteno",
      "name": "Molteno",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "867eed46",
      "slug": "molteno",
      "name": "Molteno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46570251": [{
      "hkey": "867eed46",
      "slug": "molteno",
      "name": "Molteno",
      "primary": true,
      "skipSearch": false
    }],
    "paolina": [{
      "hkey": "867eed46",
      "slug": "molteno",
      "name": "Molteno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bc168947": [{
      "hkey": "2b35f2ac",
      "slug": "case-manzoni-pascolo-coroldo",
      "name": "Case Manzoni-Pascolo-Coroldo",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;